import React, { createContext, useContext, useState } from "react";

const SidebarContext = createContext(null);

const getDefaultSidebarOpen = () => {
  if (typeof window === "undefined") return true;
  return window.innerWidth > 768; // móvil cerrado por defecto
};

export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(getDefaultSidebarOpen);

  const openSidebar = () => setIsSidebarOpen(true);
  const closeSidebar = () => setIsSidebarOpen(false);
  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  const closeSidebarOnMobile = () => {
    if (typeof window === "undefined") return;
    if (window.innerWidth <= 768) closeSidebar();
  };

  return (
    <SidebarContext.Provider
      value={{
        isSidebarOpen,
        openSidebar,
        closeSidebar,
        toggleSidebar,
        closeSidebarOnMobile,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const contextValue = useContext(SidebarContext);
  if (!contextValue) {
    throw new Error("useSidebar must be used within SidebarProvider");
  }
  return contextValue;
};